var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-back",on:{"click":function($event){return _vm.$router.back();}}},[_c('vs-icon',{attrs:{"icon":"keyboard_arrow_left"}}),_c('span',[_vm._v("ย้อนกลับ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }